const namespace = 'change-school/';

export const SCHOOL_CHANGE_LOAD_SUCCESS = `${namespace}SCHOOL_CHANGE_LOAD_SUCCESS`;
export const SCHOOL_CHANGE_LOAD_FAILURE = `${namespace}SCHOOL_CHANGE_LOAD_FAILURE`;

export const INITIALIZE_CHANGE_SCHOOL_REQUEST = `${namespace}INITIALIZE_CHANGE_SCHOOL_REQUEST`;
